@let s = stepper();
<nav class="form-pasos" [attr.aria-label]="etiqueta()">
  @for (paso of s.steps; track $index; let i = $index) {
    <button
      type="button"
      class="irx-nav form-paso"
      [class.actual]="s.selectedIndex === i"
      [class.completo]="paso.completed && !paso.hasError"
      [class.con-error]="paso.hasError"
      [attr.aria-current]="s.selectedIndex === i ? 'step' : null"
      (click)="s.selectedIndex = i"
    >
      <span class="form-paso-numero">
        @if (paso.hasError) {
          <mat-icon>priority_high</mat-icon>
        } @else if (paso.completed && s.selectedIndex !== i) {
          <mat-icon>check</mat-icon>
        } @else {
          {{ i + 1 }}
        }
      </span>
      <span class="form-paso-textos">
        <span class="form-paso-nombre">
          @if (paso.stepLabel) {
            <ng-container
              [ngTemplateOutlet]="paso.stepLabel.template"
            ></ng-container>
          } @else {
            {{ paso.label }}
          }
        </span>
        <span class="form-paso-detalle">
          @if (paso.hasError) {
            {{ paso.errorMessage || 'Campos incompletos' }}
          } @else if (paso.completed) {
            Completo
          } @else if (paso.optional) {
            Opcional
          } @else {
            Obligatorio
          }
        </span>
      </span>
    </button>
  }
</nav>
